import React, { useState, useEffect } from "react";
import useAuth from "auth/useAuth";
import Loader from "utils/Loader";
import { REPORT_FRONTEND_ERROR } from "lib/constants";
import { postAPICall } from "lib/callApi";
import ErrorFallback from "./ErrorFallback";

const SSOTokenFetch = () => {
  const [showFallback, setShowFallback] = useState(false);
  const { loadToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const provider = window.location.pathname.split("/").pop();
    const tempCode = params.get("code");
    const state = params.get("state");

    if (!tempCode) {
      setShowFallback(true);
      postAPICall(REPORT_FRONTEND_ERROR, false, {
        err: {
          message: "Code was not passed through for SSO token fetch",
        },
        clientDetails: {
          url: window.location.href,
        },
      });
    } else loadToken(provider, tempCode, state);
  }, []);

  if (showFallback) return <ErrorFallback />;

  return <Loader loading />;
};

export default SSOTokenFetch;
